import React, { FunctionComponent } from 'react'

import { useTranslation } from 'react-i18next'
import { DisplayProps, SpaceProps, WidthProps } from 'styled-system'

import { ColorBox } from '@/atoms/color-box'
import { getStatusColor } from '@/helpers/status-color'
import { Status } from '@/models/common'
import { StatusColor } from '@/styles'

interface Props {
  status: Status
  color?: StatusColor
}

const StatusComponent: FunctionComponent<Props & SpaceProps & DisplayProps & WidthProps> = ({ status, color, ...spaceProps }) => {
  const { t } = useTranslation()
  if (!status) return null

  return (
    <ColorBox bgColor={color ?? getStatusColor(status)} {...spaceProps}>
      {t(`status.${status.toUpperCase()}`)}
    </ColorBox>
  )
}

export default StatusComponent
